import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { Banner } from "@obg/mat.ui.core";
import { coerceBoolean } from "@obg/ngx.global.evo";

import { BannerConfigService } from "./banner.config";

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: "article[obg-m-common-banner]",
	templateUrl: "./banner.component.html",
	styleUrls: ["./banner.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class BannerComponent {
	@HostBinding("class.obg-m-common-banner") hostCssClass = true;
	@HostBinding("class.placeholder")
	@Input()
	@coerceBoolean()
	placeholder = false;

	@Input() banner: Banner | undefined;

	fallbackImageUrl: string | undefined;

	constructor(private bannerConfigService: BannerConfigService) {
		this.fallbackImageUrl = this.bannerConfigService.getFallbackImage()?.url;
	}
}
